import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import Notifications from "vue-notification";
import "vue-loading-overlay/dist/vue-loading.min.css";
import {
  faTimes,
  faSave,
  faCaretRight,
  faCaretDown,
  faTrashAlt,
  faPen,
  faUpload
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faTimes, faSave, faCaretRight, faCaretDown, faTrashAlt, faPen, faUpload);
Vue.component("font-awesome-icon", FontAwesomeIcon);

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("../firebase-messaging-sw.js")
//     .then(registration => {
//       // console.log("Registration successful, scope is:", registration.scope);
//     })
//     .catch(err => {
//       // console.log("Service worker registration failed, error:", err);
//     });
// }

Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(Notifications);

const lastClear = localStorage.getItem("lastClear");
const now = new Date().getTime();

if (now - lastClear > 1000 * 60 * 60 * 1) {
  localStorage.clear();
  localStorage.setItem("lastClear", now);
}

if (localStorage.getItem("rompeelmiedo.org") != null) {
  store.commit(
    "setUser",
    JSON.parse(localStorage.getItem("rompeelmiedo.org")).user
  );
}

router.beforeEach((to, from, next) => {
  if (to.path != "/login") {
    //next();
    if (store.state.user.isAuthenticated) {
      next();
    } else {
      next("login");
    }
  } else {
    // console.log(to.path)
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
